<template>
  <UIModal
    class="ModalGptRating"
    :showClose="true"
    @close="emit('close')"
    @enter="emit('close')"
  >
    <template #title>
      <slot name="title">Rate GPT</slot>
    </template>

    <template #content>
      <div class="ModalGptRating__content">
        <GptRatingForm v-model="selectedRating" />
      </div>
    </template>

    <template #actions>
      <UIButton
        :isDisabled="!selectedRating"
        :isLoading="isLoading"
        @click.prevent="emit('confirm', selectedRating)"
      >
        Submit
      </UIButton>
    </template>
  </UIModal>
</template>

<script lang="ts" setup>
import { ref, useAttrs, watch } from 'vue'

import GptRatingForm from '../gpts/GptRatingForm.vue'
import UIButton from '../ui/buttons/UIButton.vue'
import UIModal from '../ui/modals/UIModal.vue'

const attrs = useAttrs()

const emit = defineEmits(['close', 'confirm'])
withDefaults(
  defineProps<{
    isLoading?: boolean
  }>(),
  {
    isLoading: false,
  },
)

const selectedRating = ref(0)

watch(
  () => attrs.isOpen,
  () => {
    selectedRating.value = 0
  },
  { immediate: true },
)
</script>

<style lang="scss">
.ModalGptRating.UIModal {
  --modal-size: 28.125rem;

  .ModalGptRating__content {
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
  }
}
</style>
